const words = ["RedKey Digital", "AI Websites", "SEO", "Branding", "Google Ads", "Automation"];

export const Marquee = () => {
  const row = [...words, ...words];
  return (
    <section className="relative py-10 md:py-14 border-y border-border bg-muted overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {row.map((w, i) => (
          <span key={i} className="mx-8 text-6xl md:text-8xl font-heading font-extrabold tracking-tighter text-stroke flex items-center gap-8">
            {w}
            <span className="text-primary" style={{ WebkitTextStroke: "0" }}>✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
